import { useMediaLibDialogCtx } from "@editor/modules/media-lib/ctx";
import { useMediaLibDialogStoreShallow } from "@editor/modules/media-lib/stores";
import {
  type IMediaLibDialogItem,
  MediaLibPresetEnum,
} from "@editor/modules/media-lib/types";
import { LogoFinder } from "../../logo-finder";
import type { IMediaLibLogo } from "../../logo-finder/types";

export const MediaDialogLogoFinder = () => {
  const { isMultiSelect, onSelect, preset } = useMediaLibDialogCtx();
  const { toggleSelectedItem, selectedItems } = useMediaLibDialogStoreShallow(
    (s) => ({
      selectedItems: s.selectedItems,
      toggleSelectedItem: s.toggleSelectedItem,
    }),
  );
  const handleClick = (logoData: IMediaLibLogo) => {
    if (preset === MediaLibPresetEnum.OnlyVideos) return;
    const url = logoData.src;
    const item: IMediaLibDialogItem = {
      id: logoData.originalSrc,
      url,
      type: "image",
      mediaFrom: "stock-image",
      shouldUpload: true,
    };

    if (!isMultiSelect) {
      onSelect(item);
      return;
    }

    toggleSelectedItem(item);
  };

  return (
    <LogoFinder
      view="dialog"
      onSelect={handleClick}
      selectedItems={selectedItems}
      isMultiSelect={isMultiSelect}
    />
  );
};
